import { useEffect, useState } from "react";
import { Button, Rate, Input, message } from "antd";
import { useParams, useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";

const AssessmentFeedback = () => {
  const navigate = useNavigate(); // Initialize useNavigate
  const { sessionId } = useParams(); 

  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (rating === 0 || feedback.trim().length === 0) {
      message.warning("Please provide a rating and feedback before submitting.");
      return;
    }

    try {
      setLoading(true);
      await axios.post(`https://rfs-ai-interview-api-6xf7.onrender.com/api/feed/`, { sessionId, stars: rating, feedback });
      message.success("Feedback submitted successfully!");

      // Navigate to the result page after successful submission
      navigate(`/result/${sessionId}`, { replace: true, state: { sessionId } });

    } catch (error) {
      console.error("Error submitting feedback:", error);
      message.error("Failed to submit feedback. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-6">
      <div className="bg-white p-6 rounded-2xl w-full max-w-md text-center">
        <div className="text-7xl">🎉</div>
        <h2 className="text-xl font-semibold mt-3">Self Assessment Completed</h2>
      
        <h3 className="mt-5 text-lg font-medium">How would you rate your experience?</h3>

        <Rate
          className="mt-3 text-3xl"
          value={rating}
          onChange={setRating}
          style={{ fontSize: "32px" }}
        />

        <Input.TextArea
          className="mt-4 p-3 border rounded-lg"
          rows={3}
          placeholder="Please let us know if there is any additional feedback"
          value={feedback}
          onChange={(e) => setFeedback(e.target.value)}
        />

        <Button
          type="primary"
          shape="round"
          className="mt-5 bg-[#437AFF] hover:bg-blue-500 text-white font-medium"
          onClick={handleSubmit}
          disabled={rating === 0 || feedback.trim().length === 0} // Disable if no rating or empty feedback
          loading={loading} 
        >
          Submit & View Result
        </Button>

      </div>
    </div>
  );
};

export default AssessmentFeedback;
